<template>
    <div id="accordion" role="tablist" aria-multiselectable="true">
        <div class="card mb10 margin-bottom"
             :key="faq.id"
             v-for="faq in faqs">
            <div class="card-header accordion-header" role="tab" :id="`#faqHeader${faq.id}${idExtension}`">
                <h5 class="mb-0">
                    <a data-toggle="collapse" data-parent="#accordion" :href="`#faq${faq.id}${idExtension}`"
                       aria-expanded="true"
                       :aria-controls="`faq${faq.id}${idExtension}`">
                        {{ faq.question }}
                    </a>
                </h5>
            </div>
            <div :id="`faq${faq.id}${idExtension}`" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                <div class="card-body">
                    <span v-html="faq.answer"></span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'FaqsList',

    props: {
        faqs: {
            required: true,
            type: Array,
        },
        idExtension: {//to be used in cases where the list is displayed on the page twice at once e.g. in a modal and on the page itself.
            default: '',
            required: false,
            type: String,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Faqs/List.vue